module.exports = __webpack_public_path__ + "static/media/Redtag.e585762e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Redtag.PNG
// module id = 862
// module chunks = 0